export enum ChartType {
  BarLine = "Bar Line",
  GroupedBars = "Grouped Bars",
  Doughnut = "Doughnut",
  WordCloud = "Word Cloud",
  TimeSeries = "Time Series",
  TimeSeriesCombo = "Time Series Combo",
  ChatSegmentation = "Chat Segmentation",
  TextAnalysisOverview = "Text Analysis Overview",
  HeatMapCartesian = "Heatmap Cartesian",
  ScatterPlot = "Scatter Plot",
}

export const chartTypeTextMap = {
  [ChartType.BarLine]: "Bar/Line Chart",
  [ChartType.GroupedBars]: "Grouped Bar Chart",
  [ChartType.Doughnut]: "Doughnut Chart",
  [ChartType.WordCloud]: "Word Cloud",
  [ChartType.TimeSeries]: "Trend Line Chart",
  [ChartType.TimeSeriesCombo]: "Trend Line/Scatter Combo",
  [ChartType.HeatMapCartesian]: "Co-Occurrence Overview",
  [ChartType.ScatterPlot]: "Scatter Plot",
};

export enum SpecificChartType {
  BarLineCombo = "Bar Line Combo",
  GroupedBar = "Grouped Bar",
  Doughnut = "Doughnut",
  TimeSeries = "Time Series",
  TimeSeriesCombo = "Time Series Combo",
  WordCloud = "Word Cloud",
  ChatSegmentation = "Chat Segmentation",
  TextAnalysisOverview = "Text Analysis Overview",
  HeatMapCartesian = "Co-Occurrence Overview",
  ScatterPlot = "Scatter Plot",
}

export enum FieldType {
  Float = "float",
  Text = "text",
  Keyword = "keyword",
  Date = "date",
  Long = "long",
}

export enum FieldPath {
  Sentiment = "sentiment",
  Topics = "topic",
  Segment = "segment",
  Intent = "intent",
}

export enum FieldLabel {
  Tokens = "Tokens",
  Entities = "Entities",
  PartsOfSpeech = "Parts of Speech",
  MsgDateTime = "Message DateTime",
  EmitterRole = "Emitter Role",
  CumulativeEffort = "Cumulative Effort",
}

export enum GroupType {
  Predictors = "Models",
  Metrics = "Calculated Metrics",
  Structured = "Structured Fields",
}
